import * as React from "react";
import { request } from "../../../../../services/cpln";
import { Card } from "antd";
import { CardTitle } from "../../../../../components/antd/card/CardTitle";
import { CardContent } from "../../../../../components/antd/card/CardContent";
import { CardCollapsibleContent } from "../../../../../components/antd/card/CardCollapsibleContent";
import { CaretRightOutlined } from "@ant-design/icons";
import { ProviderNetworking } from "../../../advanced/providerNetworking";
import { CpSelect } from "../../../../gvc/testNewForm/CpSelect";
import { CpFormItem } from "../../../../gvc/testNewForm/CpFormItem";
import { CpErrorWarning } from "../../../../gvc/testNewForm/CpErrorWarning";
import { CpLabel } from "../../../../gvc/testNewForm/CpLabel";
import { formSetValue } from "../../../../gvc/testNewForm/utils";
import { useCpFormContext } from "../../../../../components/form/useCpFormContext";
import { CpErrorWarningArrayIcon } from "../../../../gvc/testNewForm/CpErrorWarningArrayIcon";
import { CpDirtyIndicatorArrayIcon } from "../../../../gvc/testNewForm/CpDirtyIndicatorArrayIconLink";

interface Props {}
export const GenericProviderSelf: React.FC<Props> = ({}) => {
  const { id } = useCpFormContext();

  const [locationOptions, setLocationOptions] = React.useState<any[]>([]);
  const [isAdvancedCollapsed, setIsAdvancedCollapsed] = React.useState(true);

  React.useEffect(() => {
    fetchSchemaData();
  }, []);

  async function fetchSchemaData() {
    // Locations
    try {
      const { data: schemaRes } = await request({ url: "/catalog/schema/mk8s" });
      const locations: string[] = schemaRes.keys.spec.keys.provider.keys.generic.keys.location.allow;
      setLocationOptions(locations.map((v) => ({ label: v, value: v })));
      formSetValue(id, `generic.location`, locations[0]);
    } catch (e) {
      console.error("Failed to get locations from mk8s catalog schema");
    }
  }

  return (
    <div className="cpln-form-section cpln-ant-card-container">
      <Card>
        <CardTitle>
          Generic Provider
          <CpErrorWarningArrayIcon names={[`generic.location`, `generic.networking`]} />
        </CardTitle>
        <CardContent>
          <CpFormItem>
            <CpLabel name={`generic.location`}>Location</CpLabel>
            <CpSelect name={`generic.location`} options={locationOptions} style={{ width: 600 }} />
            <CpErrorWarning name={`generic.location`} />
          </CpFormItem>
          <div className="mt-4">
            <CardTitle style={{ marginBottom: 0, fontSize: 20 }}>
              <div className={`flex items-baseline ${isAdvancedCollapsed ? "" : "mb-4"}`}>
                <div
                  className={`flex items-center gap-2 color-link-hover cursor-pointer`}
                  onClick={() => {
                    setIsAdvancedCollapsed((x) => !x);
                  }}
                >
                  <CaretRightOutlined rotate={isAdvancedCollapsed ? 0 : 90} className={`self-center`} />
                  <span>Advanced</span>
                  <CpDirtyIndicatorArrayIcon names={["provider-generic-advanced"]} />
                </div>
              </div>
            </CardTitle>
          </div>
          <CardCollapsibleContent collapsed={isAdvancedCollapsed}>
            <ProviderNetworking provider={`generic`} noMargin />
          </CardCollapsibleContent>
        </CardContent>
      </Card>
    </div>
  );
};
